export default __webpack_public_path__ + "static/media/bse-1000-index-fund-connector-mobile.dd953a1e.webp";